webpackJsonp([114276838955818,60335399758886],{

/***/ 116:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jeremy Zander","description":"Front End Javascript Engineer"}}},"layoutContext":{}}

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(225);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(116);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(49);
	var isArguments = __webpack_require__(48);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(57);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(47);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(56);
	
	var _HelmetConstants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(50));
	var shallowEqual = _interopDefault(__webpack_require__(59));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CloseButton(_ref) {
	  var closeToast = _ref.closeToast,
	      type = _ref.type,
	      ariaLabel = _ref.ariaLabel;
	  return _react.default.createElement("button", {
	    className: "Toastify__close-button Toastify__close-button--" + type,
	    type: "button",
	    onClick: closeToast,
	    "aria-label": ariaLabel
	  }, "\u2716");
	}
	
	CloseButton.propTypes = {
	  closeToast: _propTypes.default.func,
	  arialLabel: _propTypes.default.string
	};
	CloseButton.defaultProps = {
	  ariaLabel: 'close'
	};
	var _default = CloseButton;
	exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(86));
	
	var _constant = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProgressBar(_ref) {
	  var delay = _ref.delay,
	      isRunning = _ref.isRunning,
	      closeToast = _ref.closeToast,
	      type = _ref.type,
	      hide = _ref.hide,
	      className = _ref.className,
	      rtl = _ref.rtl;
	  var style = {
	    animationDuration: delay + "ms",
	    animationPlayState: isRunning ? 'running' : 'paused',
	    opacity: hide ? 0 : 1
	  };
	  var classNames = (0, _classnames.default)('Toastify__progress-bar', "Toastify__progress-bar--" + type, {
	    'Toastify__progress-bar--rtl': rtl
	  }, className);
	  return _react.default.createElement("div", {
	    className: classNames,
	    style: style,
	    onAnimationEnd: closeToast
	  });
	}
	
	ProgressBar.propTypes = {
	  /**
	   * The animation delay which determine when to close the toast
	   */
	  delay: _propTypes.default.number.isRequired,
	
	  /**
	   * Whether or not the animation is running or paused
	   */
	  isRunning: _propTypes.default.bool.isRequired,
	
	  /**
	   * Func to close the current toast
	   */
	  closeToast: _propTypes.default.func.isRequired,
	
	  /**
	   * Support rtl content
	   */
	  rtl: _propTypes.default.bool.isRequired,
	
	  /**
	   * Optional type : info, success ...
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * Hide or not the progress bar
	   */
	  hide: _propTypes.default.bool,
	
	  /**
	   * Optionnal className
	   */
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
	};
	ProgressBar.defaultProps = {
	  type: _constant.TYPE.DEFAULT,
	  hide: false
	};
	var _default = ProgressBar;
	exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(86));
	
	var _ProgressBar = _interopRequireDefault(__webpack_require__(478));
	
	var _constant = __webpack_require__(82);
	
	var _propValidator = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function getX(e) {
	  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
	}
	
	function getY(e) {
	  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
	}
	
	var noop = function noop() {};
	
	var Toast =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Toast, _Component);
	
	  function Toast() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.state = {
	      isRunning: true,
	      preventExitTransition: false
	    };
	    _this.flag = {
	      canCloseOnClick: true,
	      canDrag: false
	    };
	    _this.drag = {
	      start: 0,
	      x: 0,
	      y: 0,
	      deltaX: 0,
	      removalDistance: 0
	    };
	    _this.ref = null;
	
	    _this.pauseToast = function () {
	      if (_this.props.autoClose) {
	        _this.setState({
	          isRunning: false
	        });
	      }
	    };
	
	    _this.playToast = function () {
	      if (_this.props.autoClose) {
	        _this.setState({
	          isRunning: true
	        });
	      }
	    };
	
	    _this.onDragStart = function (e) {
	      _this.flag.canCloseOnClick = true;
	      _this.flag.canDrag = true;
	      _this.ref.style.transition = '';
	      _this.drag.start = _this.drag.x = getX(e.nativeEvent);
	      _this.drag.removalDistance = _this.ref.offsetWidth * (_this.props.draggablePercent / 100);
	    };
	
	    _this.onDragMove = function (e) {
	      if (_this.flag.canDrag) {
	        if (_this.state.isRunning) {
	          _this.pauseToast();
	        }
	
	        _this.drag.x = getX(e);
	        _this.drag.deltaX = _this.drag.x - _this.drag.start; // prevent false positif during a toast click
	
	        _this.drag.start !== _this.drag.x && (_this.flag.canCloseOnClick = false);
	        _this.ref.style.transform = "translateX(" + _this.drag.deltaX + "px)";
	        _this.ref.style.opacity = 1 - Math.abs(_this.drag.deltaX / _this.drag.removalDistance);
	      }
	    };
	
	    _this.onDragEnd = function (e) {
	      if (_this.flag.canDrag) {
	        _this.flag.canDrag = false;
	
	        if (Math.abs(_this.drag.deltaX) > _this.drag.removalDistance) {
	          _this.setState({
	            preventExitTransition: true
	          }, _this.props.closeToast);
	
	          return;
	        }
	
	        _this.drag.y = getY(e);
	        _this.ref.style.transition = 'transform 0.2s, opacity 0.2s';
	        _this.ref.style.transform = 'translateX(0)';
	        _this.ref.style.opacity = 1;
	      }
	    };
	
	    _this.onDragTransitionEnd = function () {
	      var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
	          top = _this$ref$getBounding.top,
	          bottom = _this$ref$getBounding.bottom,
	          left = _this$ref$getBounding.left,
	          right = _this$ref$getBounding.right;
	
	      if (_this.props.pauseOnHover && _this.drag.x >= left && _this.drag.x <= right && _this.drag.y >= top && _this.drag.y <= bottom) {
	        _this.pauseToast();
	      } else {
	        _this.playToast();
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = Toast.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props.onOpen(this.props.children.props);
	
	    if (this.props.draggable) {
	      this.bindDragEvents();
	    } // Maybe I could bind the event in the ToastContainer and rely on delegation
	
	
	    if (this.props.pauseOnFocusLoss) {
	      this.bindFocusEvents();
	    }
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.draggable !== this.props.draggable) {
	      if (this.props.draggable) {
	        this.bindDragEvents();
	      } else {
	        this.unbindDragEvents();
	      }
	    }
	
	    if (prevProps.pauseOnFocusLoss !== this.props.pauseOnFocusLoss) {
	      if (this.props.pauseOnFocusLoss) {
	        this.bindFocusEvents();
	      } else {
	        this.unbindFocusEvents();
	      }
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.props.onClose(this.props.children.props);
	
	    if (this.props.draggable) {
	      this.unbindDragEvents();
	    }
	
	    if (this.props.pauseOnFocusLoss) {
	      this.unbindFocusEvents();
	    }
	  };
	
	  _proto.bindFocusEvents = function bindFocusEvents() {
	    window.addEventListener('focus', this.playToast);
	    window.addEventListener('blur', this.pauseToast);
	  };
	
	  _proto.unbindFocusEvents = function unbindFocusEvents() {
	    window.removeEventListener('focus', this.playToast);
	    window.removeEventListener('blur', this.pauseToast);
	  };
	
	  _proto.bindDragEvents = function bindDragEvents() {
	    document.addEventListener('mousemove', this.onDragMove);
	    document.addEventListener('mouseup', this.onDragEnd);
	    document.addEventListener('touchmove', this.onDragMove);
	    document.addEventListener('touchend', this.onDragEnd);
	  };
	
	  _proto.unbindDragEvents = function unbindDragEvents() {
	    document.removeEventListener('mousemove', this.onDragMove);
	    document.removeEventListener('mouseup', this.onDragEnd);
	    document.removeEventListener('touchmove', this.onDragMove);
	    document.removeEventListener('touchend', this.onDragEnd);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        closeButton = _this$props.closeButton,
	        children = _this$props.children,
	        autoClose = _this$props.autoClose,
	        pauseOnHover = _this$props.pauseOnHover,
	        closeOnClick = _this$props.closeOnClick,
	        type = _this$props.type,
	        hideProgressBar = _this$props.hideProgressBar,
	        closeToast = _this$props.closeToast,
	        Transition = _this$props.transition,
	        position = _this$props.position,
	        onExited = _this$props.onExited,
	        className = _this$props.className,
	        bodyClassName = _this$props.bodyClassName,
	        progressClassName = _this$props.progressClassName,
	        updateId = _this$props.updateId,
	        role = _this$props.role,
	        rtl = _this$props.rtl;
	    var toastProps = {
	      className: (0, _classnames.default)('Toastify__toast', "Toastify__toast--" + type, {
	        'Toastify__toast--rtl': rtl
	      }, className)
	    };
	
	    if (autoClose && pauseOnHover) {
	      toastProps.onMouseEnter = this.pauseToast;
	      toastProps.onMouseLeave = this.playToast;
	    } // prevent toast from closing when user drags the toast
	
	
	    if (closeOnClick) {
	      toastProps.onClick = function () {
	        return _this2.flag.canCloseOnClick && closeToast();
	      };
	    }
	
	    return _react.default.createElement(Transition, {
	      in: this.props.in,
	      appear: true,
	      unmountOnExit: true,
	      onExited: onExited,
	      position: position,
	      preventExitTransition: this.state.preventExitTransition
	    }, _react.default.createElement("div", _extends({}, toastProps, {
	      ref: function ref(_ref) {
	        return _this2.ref = _ref;
	      },
	      onMouseDown: this.onDragStart,
	      onTouchStart: this.onDragStart,
	      onTransitionEnd: this.onDragTransitionEnd
	    }), _react.default.createElement("div", _extends({}, this.props.in && {
	      role: role
	    }, {
	      className: (0, _classnames.default)('Toastify__toast-body', bodyClassName)
	    }), children), closeButton && closeButton, autoClose && _react.default.createElement(_ProgressBar.default, _extends({}, updateId ? {
	      key: "pb-" + updateId
	    } : {}, {
	      rtl: rtl,
	      delay: autoClose,
	      isRunning: this.state.isRunning,
	      closeToast: closeToast,
	      hide: hideProgressBar,
	      type: type,
	      className: progressClassName
	    }))));
	  };
	
	  return Toast;
	}(_react.Component);
	
	Toast.propTypes = {
	  closeButton: _propValidator.falseOrElement.isRequired,
	  autoClose: _propValidator.falseOrDelay.isRequired,
	  children: _propTypes.default.node.isRequired,
	  closeToast: _propTypes.default.func.isRequired,
	  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)).isRequired,
	  pauseOnHover: _propTypes.default.bool.isRequired,
	  pauseOnFocusLoss: _propTypes.default.bool.isRequired,
	  closeOnClick: _propTypes.default.bool.isRequired,
	  transition: _propTypes.default.func.isRequired,
	  rtl: _propTypes.default.bool.isRequired,
	  hideProgressBar: _propTypes.default.bool.isRequired,
	  draggable: _propTypes.default.bool.isRequired,
	  draggablePercent: _propTypes.default.number.isRequired,
	  in: _propTypes.default.bool,
	  onExited: _propTypes.default.func,
	  onOpen: _propTypes.default.func,
	  onClose: _propTypes.default.func,
	  type: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.TYPE)),
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	  updateId: _propTypes.default.number,
	  ariaLabel: _propTypes.default.string
	};
	Toast.defaultProps = {
	  type: _constant.TYPE.DEFAULT,
	  in: true,
	  onOpen: noop,
	  onClose: noop,
	  className: null,
	  bodyClassName: null,
	  progressClassName: null,
	  updateId: null,
	  role: 'alert'
	};
	var _default = Toast;
	exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(86));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(484));
	
	var _Toast = _interopRequireDefault(__webpack_require__(479));
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(477));
	
	var _Transitions = __webpack_require__(205);
	
	var _constant = __webpack_require__(82);
	
	var _eventManager = _interopRequireDefault(__webpack_require__(207));
	
	var _propValidator = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var ToastContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ToastContainer, _Component);
	
	  function ToastContainer() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.state = {
	      toast: []
	    };
	    _this.collection = {};
	
	    _this.isToastActive = function (id) {
	      return _this.state.toast.indexOf(parseInt(id, 10)) !== -1;
	    };
	
	    return _this;
	  }
	
	  var _proto = ToastContainer.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _eventManager.default.on(_constant.ACTION.SHOW, function (content, options) {
	      return _this2.show(content, options);
	    }).on(_constant.ACTION.CLEAR, function (id) {
	      return id !== null ? _this2.removeToast(id) : _this2.clear();
	    }).emit(_constant.ACTION.DID_MOUNT, this);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    _eventManager.default.off(_constant.ACTION.SHOW).off(_constant.ACTION.CLEAR).emit(_constant.ACTION.WILL_UNMOUNT);
	  };
	
	  _proto.removeToast = function removeToast(id) {
	    this.setState({
	      toast: this.state.toast.filter(function (v) {
	        return v !== parseInt(id, 10);
	      })
	    }, this.dispatchChange);
	  };
	
	  _proto.dispatchChange = function dispatchChange() {
	    _eventManager.default.emit(_constant.ACTION.ON_CHANGE, this.state.toast.length);
	  };
	
	  _proto.makeCloseButton = function makeCloseButton(toastClose, toastId, type) {
	    var _this3 = this;
	
	    var closeButton = this.props.closeButton;
	
	    if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
	      closeButton = toastClose;
	    }
	
	    return closeButton === false ? false : (0, _react.cloneElement)(closeButton, {
	      closeToast: function closeToast() {
	        return _this3.removeToast(toastId);
	      },
	      type: type
	    });
	  };
	
	  _proto.getAutoCloseDelay = function getAutoCloseDelay(toastAutoClose) {
	    return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
	  };
	
	  _proto.canBeRendered = function canBeRendered(content) {
	    return (0, _react.isValidElement)(content) || typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
	  };
	
	  _proto.parseClassName = function parseClassName(prop) {
	    if (typeof prop === 'string') {
	      return prop;
	    } else if (prop !== null && typeof prop === 'object' && 'toString' in prop) {
	      return prop.toString();
	    }
	
	    return null;
	  };
	
	  _proto.show = function show(content, options) {
	    var _this4 = this,
	        _extends2;
	
	    if (!this.canBeRendered(content)) {
	      throw new Error("The element you provided cannot be rendered. You provided an element of type " + typeof content);
	    }
	
	    var toastId = options.toastId;
	
	    var closeToast = function closeToast() {
	      return _this4.removeToast(toastId);
	    };
	
	    var toastOptions = {
	      id: toastId,
	      type: options.type,
	      closeToast: closeToast,
	      updateId: options.updateId,
	      rtl: this.props.rtl,
	      position: options.position || this.props.position,
	      transition: options.transition || this.props.transition,
	      className: this.parseClassName(options.className || this.props.toastClassName),
	      bodyClassName: this.parseClassName(options.bodyClassName || this.props.bodyClassName),
	      closeButton: this.makeCloseButton(options.closeButton, toastId, options.type),
	      pauseOnHover: typeof options.pauseOnHover === 'boolean' ? options.pauseOnHover : this.props.pauseOnHover,
	      pauseOnFocusLoss: typeof options.pauseOnFocusLoss === 'boolean' ? options.pauseOnFocusLoss : this.props.pauseOnFocusLoss,
	      draggable: typeof options.draggable === 'boolean' ? options.draggable : this.props.draggable,
	      draggablePercent: typeof options.draggablePercent === 'number' && !isNaN(options.draggablePercent) ? options.draggablePercent : this.props.draggablePercent,
	      closeOnClick: typeof options.closeOnClick === 'boolean' ? options.closeOnClick : this.props.closeOnClick,
	      progressClassName: this.parseClassName(options.progressClassName || this.props.progressClassName),
	      autoClose: this.getAutoCloseDelay(options.autoClose),
	      hideProgressBar: typeof options.hideProgressBar === 'boolean' ? options.hideProgressBar : this.props.hideProgressBar
	    };
	    typeof options.onOpen === 'function' && (toastOptions.onOpen = options.onOpen);
	    typeof options.onClose === 'function' && (toastOptions.onClose = options.onClose); // add closeToast function to react component only
	
	    if ((0, _react.isValidElement)(content) && typeof content.type !== 'string' && typeof content.type !== 'number') {
	      content = (0, _react.cloneElement)(content, {
	        closeToast: closeToast
	      });
	    } else if (typeof content === 'function') {
	      content = content({
	        closeToast: closeToast
	      });
	    }
	
	    this.collection = _extends({}, this.collection, (_extends2 = {}, _extends2[toastId] = {
	      position: toastOptions.position,
	      options: toastOptions,
	      content: content
	    }, _extends2));
	    this.setState({
	      toast: toastOptions.updateId ? _toConsumableArray(this.state.toast) : _toConsumableArray(this.state.toast).concat([toastId])
	    }, this.dispatchChange);
	  };
	
	  _proto.makeToast = function makeToast(content, options) {
	    return _react.default.createElement(_Toast.default, _extends({}, options, {
	      isDocumentHidden: this.state.isDocumentHidden,
	      key: "toast-" + options.id
	    }), content);
	  };
	
	  _proto.clear = function clear() {
	    this.setState({
	      toast: []
	    });
	  };
	
	  _proto.renderToast = function renderToast() {
	    var _this5 = this;
	
	    var toastToRender = {};
	    var _this$props = this.props,
	        className = _this$props.className,
	        style = _this$props.style,
	        newestOnTop = _this$props.newestOnTop;
	    var collection = newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection); // group toast by position
	
	    collection.forEach(function (toastId) {
	      var toast = _this5.collection[toastId];
	      toastToRender[toast.position] || (toastToRender[toast.position] = []);
	
	      if (_this5.state.toast.indexOf(parseInt(toastId, 10)) !== -1) {
	        toastToRender[toast.position].push(_this5.makeToast(toast.content, toast.options));
	      } else {
	        toastToRender[toast.position].push(null);
	        delete _this5.collection[toastId];
	      }
	    });
	    return Object.keys(toastToRender).map(function (position) {
	      var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
	      var props = {
	        className: (0, _classnames.default)('Toastify__toast-container', "Toastify__toast-container--" + position, {
	          'Toastify__toast-container--rtl': _this5.props.rtl
	        }, _this5.parseClassName(className)),
	        style: disablePointer ? _extends({}, style, {
	          pointerEvents: 'none'
	        }) : _extends({}, style)
	      };
	      return _react.default.createElement(_TransitionGroup.default, _extends({}, props, {
	        key: "container-" + position
	      }), toastToRender[position]);
	    });
	  };
	
	  _proto.render = function render() {
	    return _react.default.createElement("div", {
	      className: "Toastify"
	    }, this.renderToast());
	  };
	
	  return ToastContainer;
	}(_react.Component);
	
	ToastContainer.propTypes = {
	  /**
	   * Set toast position
	   */
	  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)),
	
	  /**
	   * Disable or set autoClose delay
	   */
	  autoClose: _propValidator.falseOrDelay,
	
	  /**
	   * Disable or set a custom react element for the close button
	   */
	  closeButton: _propValidator.falseOrElement,
	
	  /**
	   * Hide or not progress bar when autoClose is enabled
	   */
	  hideProgressBar: _propTypes.default.bool,
	
	  /**
	   * Pause toast duration on hover
	   */
	  pauseOnHover: _propTypes.default.bool,
	
	  /**
	   * Dismiss toast on click
	   */
	  closeOnClick: _propTypes.default.bool,
	
	  /**
	   * Newest on top
	   */
	  newestOnTop: _propTypes.default.bool,
	
	  /**
	   * An optional className
	   */
	  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional style
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * An optional className for the toast
	   */
	  toastClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional className for the toast body
	   */
	  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * An optional className for the toast progress bar
	   */
	  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
	
	  /**
	   * Define enter and exit transition using react-transition-group
	   */
	  transition: _propTypes.default.func,
	
	  /**
	   * Support rtl display
	   */
	  rtl: _propTypes.default.bool,
	
	  /**
	   * Allow toast to be draggable
	   */
	  draggable: _propTypes.default.bool,
	
	  /**
	   * The percentage of the toast's width it takes for a drag to dismiss a toast
	   */
	  draggablePercent: _propTypes.default.number,
	
	  /**
	   * Pause the toast on focus loss
	   */
	  pauseOnFocusLoss: _propTypes.default.bool
	};
	ToastContainer.defaultProps = {
	  position: _constant.POSITION.TOP_RIGHT,
	  transition: _Transitions.Bounce,
	  rtl: false,
	  autoClose: 5000,
	  hideProgressBar: false,
	  closeButton: _react.default.createElement(_CloseButton.default, null),
	  pauseOnHover: true,
	  pauseOnFocusLoss: true,
	  closeOnClick: true,
	  newestOnTop: false,
	  draggable: true,
	  draggablePercent: 80,
	  className: null,
	  style: null,
	  toastClassName: null,
	  bodyClassName: null,
	  progressClassName: null
	};
	var _default = ToastContainer;
	exports.default = _default;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Flip = exports.Zoom = exports.Slide = exports.Bounce = void 0;
	
	var _cssTransition = _interopRequireDefault(__webpack_require__(206));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bounce = (0, _cssTransition.default)({
	  enter: 'Toastify__bounce-enter',
	  exit: 'Toastify__bounce-exit',
	  appendPosition: true
	});
	exports.Bounce = Bounce;
	var Slide = (0, _cssTransition.default)({
	  enter: 'Toastify__slide-enter',
	  exit: 'Toastify__slide-exit',
	  duration: [450, 750],
	  appendPosition: true
	});
	exports.Slide = Slide;
	var Zoom = (0, _cssTransition.default)({
	  enter: 'Toastify__zoom-enter',
	  exit: 'Toastify__zoom-exit'
	});
	exports.Zoom = Zoom;
	var Flip = (0, _cssTransition.default)({
	  enter: 'Toastify__flip-enter',
	  exit: 'Toastify__flip-exit'
	});
	exports.Flip = Flip;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ToastContainer = _interopRequireDefault(__webpack_require__(480));
	
	exports.ToastContainer = _ToastContainer.default;
	
	var _Transitions = __webpack_require__(205);
	
	exports.Bounce = _Transitions.Bounce;
	exports.Slide = _Transitions.Slide;
	exports.Zoom = _Transitions.Zoom;
	exports.Flip = _Transitions.Flip;
	
	var _toast = _interopRequireDefault(__webpack_require__(482));
	
	exports.toast = _toast.default;
	
	var _cssTransition = _interopRequireDefault(__webpack_require__(206));
	
	exports.cssTransition = _cssTransition.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _eventManager = _interopRequireDefault(__webpack_require__(207));
	
	var _constant = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var container = null;
	var queue = [];
	var toastId = 0;
	
	var noop = function noop() {
	  return false;
	};
	/**
	 * Merge provided options with the defaults settings and generate the toastId
	 */
	
	
	function mergeOptions(options, type) {
	  return _extends({}, options, {
	    type: type,
	    toastId: ++toastId
	  });
	}
	/**
	 * Dispatch toast. If the container is not mounted, the toast is enqueued
	 */
	
	
	function emitEvent(content, options) {
	  if (container !== null) {
	    _eventManager.default.emit(_constant.ACTION.SHOW, content, options);
	  } else {
	    queue.push({
	      action: _constant.ACTION.SHOW,
	      content: content,
	      options: options
	    });
	  }
	
	  return options.toastId;
	}
	
	var toast = _extends(function (content, options) {
	  return emitEvent(content, mergeOptions(options, options && options.type || _constant.TYPE.DEFAULT));
	}, {
	  success: function success(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.SUCCESS));
	  },
	  info: function info(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.INFO));
	  },
	  warn: function warn(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
	  },
	  warning: function warning(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
	  },
	  error: function error(content, options) {
	    return emitEvent(content, mergeOptions(options, _constant.TYPE.ERROR));
	  },
	  dismiss: function dismiss(id) {
	    if (id === void 0) {
	      id = null;
	    }
	
	    return container && _eventManager.default.emit(_constant.ACTION.CLEAR, id);
	  },
	  isActive: noop,
	  update: function update(toastId, options) {
	    setTimeout(function () {
	      if (container && typeof container.collection[toastId] !== 'undefined') {
	        var _container$collection = container.collection[toastId],
	            oldOptions = _container$collection.options,
	            oldContent = _container$collection.content;
	        var updateId = oldOptions.updateId ? oldOptions.updateId + 1 : 1;
	
	        var nextOptions = _extends({}, oldOptions, options, {
	          toastId: toastId,
	          updateId: updateId
	        });
	
	        var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
	        delete nextOptions.render;
	        emitEvent(content, nextOptions);
	      }
	    }, 0);
	  },
	  onChange: function onChange(callback) {
	    if (typeof callback === 'function') {
	      _eventManager.default.on(_constant.ACTION.ON_CHANGE, callback);
	    }
	  },
	  POSITION: _constant.POSITION,
	  TYPE: _constant.TYPE
	});
	/**
	 * Wait until the ToastContainer is mounted to dispatch the toast
	 * and attach isActive method
	 */
	
	
	_eventManager.default.on(_constant.ACTION.DID_MOUNT, function (containerInstance) {
	  container = containerInstance;
	
	  toast.isActive = function (id) {
	    return container.isToastActive(id);
	  };
	
	  queue.forEach(function (item) {
	    _eventManager.default.emit(item.action, item.content, item.options);
	  });
	  queue = [];
	}).on(_constant.ACTION.WILL_UNMOUNT, function () {
	  container = null;
	  toast.isActive = noop;
	  toastId = 0;
	});
	
	var _default = toast;
	exports.default = _default;

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.ACTION = exports.TYPE = exports.POSITION = void 0;
	var POSITION = {
	  TOP_LEFT: 'top-left',
	  TOP_RIGHT: 'top-right',
	  TOP_CENTER: 'top-center',
	  BOTTOM_LEFT: 'bottom-left',
	  BOTTOM_RIGHT: 'bottom-right',
	  BOTTOM_CENTER: 'bottom-center'
	};
	exports.POSITION = POSITION;
	var TYPE = {
	  INFO: 'info',
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  ERROR: 'error',
	  DEFAULT: 'default'
	};
	exports.TYPE = TYPE;
	var ACTION = {
	  SHOW: 0,
	  CLEAR: 1,
	  DID_MOUNT: 2,
	  WILL_UNMOUNT: 3,
	  ON_CHANGE: 4
	};
	exports.ACTION = ACTION;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = _default;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(483));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var noop = function noop() {};
	
	function _default(_ref) {
	  var enter = _ref.enter,
	      exit = _ref.exit,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === void 0 ? 750 : _ref$duration,
	      _ref$appendPosition = _ref.appendPosition,
	      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition;
	  return function Animation(_ref2) {
	    var children = _ref2.children,
	        position = _ref2.position,
	        preventExitTransition = _ref2.preventExitTransition,
	        props = _objectWithoutPropertiesLoose(_ref2, ["children", "position", "preventExitTransition"]);
	
	    var enterClassName = appendPosition ? enter + "--" + position : enter;
	    var exitClassName = appendPosition ? exit + "--" + position : exit;
	    var enterDuration, exitDuration;
	
	    if (Array.isArray(duration) && duration.length === 2) {
	      enterDuration = duration[0];
	      exitDuration = duration[1];
	    } else {
	      enterDuration = exitDuration = duration;
	    }
	
	    var onEnter = function onEnter(node) {
	      node.classList.add(enterClassName);
	      node.style.animationFillMode = 'forwards';
	      node.style.animationDuration = enterDuration * 0.001 + "s";
	    };
	
	    var onEntered = function onEntered(node) {
	      node.classList.remove(enterClassName);
	      node.style.cssText = '';
	    };
	
	    var onExit = function onExit(node) {
	      node.classList.add(exitClassName);
	      node.style.animationFillMode = 'forwards';
	      node.style.animationDuration = exitDuration * 0.001 + "s";
	    };
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      timeout: preventExitTransition ? 0 : {
	        enter: enterDuration,
	        exit: exitDuration
	      },
	      onEnter: onEnter,
	      onEntered: onEntered,
	      onExit: preventExitTransition ? noop : onExit
	    }), children);
	  };
	}

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var eventManager = {
	  list: new Map(),
	  on: function on(event, callback) {
	    this.list.has(event) || this.list.set(event, []);
	    this.list.get(event).push(callback);
	    return this;
	  },
	  off: function off(event) {
	    if (event === void 0) {
	      event = null;
	    }
	
	    this.list.delete(event);
	    return this;
	  },
	  emit: function emit(event) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (!this.list.has(event)) {
	      return false;
	    }
	
	    this.list.get(event).forEach(function (callback) {
	      return setTimeout(function () {
	        return callback.call.apply(callback, [null].concat(args));
	      }, 0);
	    });
	    return true;
	  }
	};
	var _default = eventManager;
	exports.default = _default;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isValidDelay = isValidDelay;
	exports.objectValues = objectValues;
	exports.falseOrElement = exports.falseOrDelay = void 0;
	
	var _react = __webpack_require__(1);
	
	function isValidDelay(val) {
	  return typeof val === 'number' && !isNaN(val) && val > 0;
	}
	
	function objectValues(obj) {
	  return Object.keys(obj).map(function (key) {
	    return obj[key];
	  });
	}
	
	function withRequired(fn) {
	  fn.isRequired = function (props, propName, componentName) {
	    var prop = props[propName];
	
	    if (typeof prop === 'undefined') {
	      return new Error("The prop " + propName + " is marked as required in \n      " + componentName + ", but its value is undefined.");
	    }
	
	    fn(props, propName, componentName);
	  };
	
	  return fn;
	}
	
	var falseOrDelay = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !isValidDelay(prop)) {
	    return new Error(componentName + " expect " + propName + " \n      to be a valid Number > 0 or equal to false. " + prop + " given.");
	  }
	
	  return null;
	});
	exports.falseOrDelay = falseOrDelay;
	var falseOrElement = withRequired(function (props, propName, componentName) {
	  var prop = props[propName];
	
	  if (prop !== false && !(0, _react.isValidElement)(prop)) {
	    return new Error(componentName + " expect " + propName + " \n      to be a valid react element or equal to false. " + prop + " given.");
	  }
	
	  return null;
	});
	exports.falseOrElement = falseOrElement;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(209);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(122);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactLifecyclesCompat = __webpack_require__(201);
	
	var _PropTypes = __webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null // allows for nested Transitions
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return { status: EXITED };
	    }
	    return null;
	  };
	
	  // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	
	  //   return { nextStatus }
	  // }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	    this.updateStatus(false, nextStatus);
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var nextStatus = arguments[1];
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	
	  // Name the function so it is clearer in the documentation
	} : {};function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(209);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(201);
	
	var _ChildMapping = __webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	
	  /**
	   * The `<TransitionGroup>` component manages a set of `<Transition>` components
	   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	   * state machine for managing the mounting and unmounting of components over
	   * time.
	   *
	   * Consider the example below using the `Fade` CSS transition from before.
	   * As items are removed or added to the TodoList the `in` prop is toggled
	   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	   * component in a `<TransitionGroup>`, not just css.
	   *
	   * ## Example
	   *
	   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual `<Transition>`
	   * components. This means you can mix and match animations across different
	   * list items.
	   */
	};
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var handleExited = _this.handleExited.bind(_this);
	
	    // Initial children should all be entering, dependent on appear
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    this.setState(function (state) {
	      var children = _extends({}, state.children);
	
	      delete children[child.key];
	      return { children: children };
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = values(this.state.children).map(childFactory);
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(486);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(485)();
	}


/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	
	    if (!(0, _react.isValidElement)(child)) return;
	
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	    // item is new (entering)
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, { in: false });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	
	  return children;
	}

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterDone: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitDone: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        'footer',
	        { id: 'footer', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'ul',
	            { className: 'icons' },
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'mailto:jeremyzander@gmail.com', className: 'icon fa-envelope' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Email'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://github.com/jzander', className: 'icon fa-github' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'GitHub'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'tel:15167764428', className: 'icon fa-phone' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'label' },
	                        'Phone'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'copyright' },
	            _react2.default.createElement(
	                'a',
	                { href: 'mailto:jeremyzander@gmail.com' },
	                'jeremy.zander@gmail.com'
	            )
	        )
	    );
	};
	
	Footer.propTypes = {
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JeremyZander = __webpack_require__(326);
	
	var _JeremyZander2 = _interopRequireDefault(_JeremyZander);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import headshot from '../images/headshot.jpg';
	
	var Header = function Header(props) {
	  return _react2.default.createElement(
	    'header',
	    { id: 'header', style: props.timeout ? { display: 'none' } : {} },
	    _react2.default.createElement(
	      'div',
	      { className: 'logo' },
	      _react2.default.createElement('span', { className: 'icon fa-code head-icon' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Jeremy Zander'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I build fully-customized pixel perfect front end web applications with modern Javascript technologies like ReactJS and AngularJS.',
	          _react2.default.createElement('br', null),
	          '\xA0',
	          _react2.default.createElement('br', null),
	          'I love creating and optimizing user experiences.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'nav',
	      null,
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: _JeremyZander2.default, download: true },
	            'Resume'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:jeremy.zander@gmail.com' },
	            'Email'
	          )
	        )
	      )
	    )
	  );
	};
	
	Header.propTypes = {
	  onOpenArticle: _react2.default.PropTypes.func,
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToastify = __webpack_require__(481);
	
	__webpack_require__(313);
	
	var _pic = __webpack_require__(507);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(508);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _nextstepdegrees = __webpack_require__(506);
	
	var _nextstepdegrees2 = _interopRequireDefault(_nextstepdegrees);
	
	var _idearoom = __webpack_require__(505);
	
	var _idearoom2 = _interopRequireDefault(_idearoom);
	
	var _surfair = __webpack_require__(509);
	
	var _surfair2 = _interopRequireDefault(_surfair);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main(props) {
	    _classCallCheck(this, Main);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.resetComponent = function () {
	      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      setTimeout(function () {
	        _this.setState({
	          isSubmitted: !nextProps.isArticleVisible
	        });
	      }, 500);
	    };
	
	    _this.state = {
	      isSubmitted: false
	    };
	    return _this;
	  }
	
	  Main.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.resetComponent(nextProps);
	  };
	
	  Main.prototype.handleSubmit = function handleSubmit(event) {
	    var _this2 = this;
	
	    event.preventDefault();
	    var data = new FormData(event.target);
	    var options = {
	      hideProgressBar: true,
	      closeButton: false,
	      position: _reactToastify.toast.POSITION.TOP_CENTER,
	      className: {
	        background: '#00b57d'
	      }
	    };
	    fetch('https://script.google.com/macros/s/AKfycbwsyr2v3KuyXnms7Zi2fpixYB2Tpa_LjfXXuv9-/exec', {
	      method: 'POST',
	      body: data
	    }).then(function (response) {
	      if (response.status === 200) {
	        _reactToastify.toast.success('Sent. I will get back to you shortly', options);
	        setTimeout(function () {
	          _this2.props.onCloseArticle();
	        }, 2000);
	      } else {
	        _reactToastify.toast.error('Something went wrong. Try again later', options);
	      }
	    });
	  };
	
	  // confirmation() {
	  //   const { isSubmitted } = this.state
	  //   if (isSubmitted) {
	  //     return (
	  //       <div>
	  //         <h2 className="major">Sent</h2>
	  //         <h3>I'll get back to you soon.</h3>
	  //         <br/>
	  //       </div>
	  //     )
	  //   }
	  //   else {
	  //     return
	  //   }
	  // };
	
	  Main.prototype.render = function render() {
	    var _this3 = this;
	
	    var close = _react2.default.createElement('div', {
	      className: 'close',
	      onClick: function onClick() {
	        _this3.props.onCloseArticle();
	      }
	    });
	
	    var isSubmitted = this.state.isSubmitted;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        id: 'main',
	        style: this.props.timeout ? { display: 'flex' } : { display: 'none' }, onClick: function onClick(e) {
	          return e.stopPropagation();
	        }
	      },
	      _react2.default.createElement(_reactToastify.ToastContainer, null),
	      _react2.default.createElement(
	        'article',
	        {
	          id: 'intro',
	          className: (this.props.article === 'intro' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''),
	          style: { display: 'none' }
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Intro'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Aenean ornare velit lacus, ac varius enim ullamcorper eu. Proin aliquam facilisis ante interdum congue. Integer mollis, nisl amet convallis, porttitor magna ullamcorper, amet egestas mauris. Ut magna finibus nisi nec lacinia. Nam maximus erat id euismod egestas. By the way, check out my ',
	          _react2.default.createElement(
	            'a',
	            { href: '#work' },
	            'awesome work'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dapibus rutrum facilisis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Etiam tristique libero eu nibh porttitor fermentum. Nullam venenatis erat id vehicula viverra. Nunc ultrices eros ut ultricies condimentum. Mauris risus lacus, blandit sit amet venenatis non, bibendum vitae dolor. Nunc lorem mauris, fringilla in aliquam at, euismod in lectus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In non lorem sit amet elit placerat maximus. Pellentesque aliquam maximus risus, vel sed vehicula.'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        {
	          id: 'work',
	          className: (this.props.article === 'work' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''),
	          style: { display: 'none' }
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Surf Airlines'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _surfair2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'As the sole in-house Front End Engineer for almost 4 years, my responsibilities include working with designers, business stakeholders, and other engineers to create simplified, functional, and responsive user experiences for customer facing and internal front end systems of Surf Air technologies using ReactJS and AngularJS. Primarily focused on the front end development and maintenance of various web applications connected to RESTful API backends on NodeJS, Python, and Perl. Each application has numerous integrations with various third party services as tools for analytics, lead generation, and more. Systems all deployed using automated build processes and workflow version control with Git. Implemented tasks such as ESLint to maintain code consistency and quality with ease.'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://us.surfair.com',
	            target: '_blank', rel: 'noreferrer',
	            className: 'work-button'
	          },
	          _react2.default.createElement(
	            'button',
	            null,
	            'View website'
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Idea Room'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _idearoom2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Every successful business starts with an idea. Idea Room is a website development and digital marketing team that helps companies launch new products & services or re-position and re-purpose existing offerings. Specializing in digital marketing, the\xA0',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://idearoom.la', target: '_blank' },
	            'Idearoom.la'
	          ),
	          '\xA0website uses video and scrolling animations to help tell the user a story about how the company can help clients take their businesses to the next level.'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://idearoom.la', target: '_blank', className: 'work-button' },
	          _react2.default.createElement(
	            'button',
	            null,
	            'View website'
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Next Step Degrees'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _nextstepdegrees2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Next Step Degrees is designed to offer specialized career training & education for college graduates and individuals interested in pursuing new careers in a variety of professions. This clean and minimal design was built with ReactJS along with GatsbyJS and uses third party integration for a client needing to get to market quickly.'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://nextstepdegrees.com',
	            target: '_blank',
	            className: 'work-button'
	          },
	          _react2.default.createElement(
	            'button',
	            null,
	            'View website'
	          )
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        {
	          id: 'about',
	          className: (this.props.article === 'about' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''),
	          style: {
	            display: 'none'
	          }
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          ' About '
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          ' ',
	          'Lorem ipsum dolor sit amet, consectetur et adipiscing elit.Praesent eleifend dignissim arcu, at eleifend sapien imperdiet ac.Aliquam erat volutpat.Praesent urna nisi, fringila lorem et vehicula lacinia quam.Integer sollicitudin mauris nec lorem luctus ultrices.Aliquam libero et malesuada fames ac ante ipsum primis in faucibus.Cras viverra ligula sit amet ex mollis mattis lorem ipsum dolor sit amet.'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        {
	          id: 'message',
	          className: (this.props.article === 'contact' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''),
	          style: { display: 'none' }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            { className: 'major' },
	            'Reach out'
	          ),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: function onSubmit(e) {
	                return _this3.handleSubmit(e);
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'field half first' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'name' },
	                'Name'
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'name', id: 'name' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field half' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'email' },
	                'Email'
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'email', id: 'email' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'message' },
	                'Message'
	              ),
	              _react2.default.createElement('textarea', { name: 'message', id: 'message', rows: '4' })
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement('input', {
	                  type: 'submit',
	                  value: 'Send Message',
	                  className: 'special'
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement('input', { type: 'reset', value: 'Reset' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'icons' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                target: '_blank',
	                href: 'mailto:jeremyzander@gmail.com',
	                className: 'icon fa-envelope'
	              },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                ' Email '
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                target: '_blank',
	                href: 'https://github.com/jzander',
	                className: 'icon fa-github'
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                'GitHub'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                target: '_blank',
	                href: 'tel:15167764428',
	                className: 'icon fa-phone'
	              },
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'label' },
	                ' Phone '
	              )
	            )
	          )
	        ),
	        close
	      )
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	Main.propTypes = {
	  route: _react2.default.PropTypes.object,
	  article: _react2.default.PropTypes.string,
	  articleTimeout: _react2.default.PropTypes.bool,
	  onCloseArticle: _react2.default.PropTypes.func,
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/JeremyZander2020.dcfeb034.pdf";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/idearoom.e71c3679.png";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nextstepdegrees.f9d64b1b.png";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.55e1797f.jpg";

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/surfair.fdae7709.png";

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(393);
	
	var _reactHelmet = __webpack_require__(55);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(223);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(224);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(222);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isArticleVisible: false,
	      timeout: false,
	      articleTimeout: false,
	      article: '',
	      loading: 'is-loading'
	    };
	    _this.handleOpenArticle = _this.handleOpenArticle.bind(_this);
	    _this.handleCloseArticle = _this.handleCloseArticle.bind(_this);
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.handleOpenArticle = function handleOpenArticle(article) {
	    var _this3 = this;
	
	    this.setState({
	      isArticleVisible: !this.state.isArticleVisible,
	      article: article
	    });
	
	    setTimeout(function () {
	      _this3.setState({
	        timeout: !_this3.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this3.setState({
	        articleTimeout: !_this3.state.articleTimeout
	      });
	    }, 350);
	  };
	
	  Template.prototype.handleCloseArticle = function handleCloseArticle() {
	    var _this4 = this;
	
	    this.setState({
	      articleTimeout: !this.state.articleTimeout
	    });
	
	    setTimeout(function () {
	      _this4.setState({
	        timeout: !_this4.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this4.setState({
	        isArticleVisible: !_this4.state.isArticleVisible,
	        article: ''
	      });
	    }, 350);
	  };
	
	  Template.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    var rootPath = '/';
	
	    var content = void 0;
	
	    if (location.pathname === rootPath) {
	      content = _react2.default.createElement(
	        'div',
	        { id: 'wrapper', onClick: this.state.article === 'work' && this.handleCloseArticle },
	        _react2.default.createElement(_Header2.default, { onOpenArticle: this.handleOpenArticle, timeout: this.state.timeout }),
	        _react2.default.createElement(_Main2.default, {
	          isArticleVisible: this.state.isArticleVisible,
	          timeout: this.state.timeout,
	          articleTimeout: this.state.articleTimeout,
	          article: this.state.article,
	          onCloseArticle: this.handleCloseArticle
	        }),
	        _react2.default.createElement(_Footer2.default, { timeout: this.state.timeout })
	      );
	    } else {
	      content = _react2.default.createElement(
	        'div',
	        { id: 'wrapper', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              maxWidth: '1140px'
	            } },
	          children()
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading + ' ' + (this.state.isArticleVisible ? 'is-article-visible' : '') },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	      ),
	      content,
	      _react2.default.createElement('div', { id: 'bg' })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5cfdd91330c92e22eff1.js